import { combineLatest, MonoTypeOperatorFunction, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Reemits the last value (if it exists) every time `event` emits.
 * @param event the event which triggers repeated emissions
 */
export function repeatOn<T>(event: Observable<unknown>): MonoTypeOperatorFunction<T> {
	return (obs) => combineLatest([
		event,
		obs,
	]).pipe(
		map(([_, value]) => value),
	);
}